var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flow_across menu_space_across"},[_c('ehr-student-other-dropdown',{staticClass:"flow_across_last_item"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }